
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"140","height":"121"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{staticStyle:{"font-kerning":"normal"},attrs:{"dominant-baseline":"text-before-edge","fill":"#fff","font-family":"'Istok Web','IstokWeb-Regular'","font-size":"28","letter-spacing":".2","transform":"translate(-1 -8)"}},[_c('tspan',{staticStyle:{"font-kerning":"normal"}},[_v('View / Edit')])]),_c('path',{attrs:{"fill":"#fff","d":"M72.62 64.187l9.86 7 3-4.26.106-.164a2.22 2.22 0 00-.636-2.936l-6.22-4.42-.14-.09a2.24 2.24 0 00-2.97.62zm3.2 11.04v-.04l.098.079a1.16 1.16 0 01.182 1.531l-10.358 14.63-.082.103a1.151 1.151 0 01-1.53.167 1.14 1.14 0 01-.27-1.6l10.358-14.59.078-.098a1.152 1.152 0 011.524-.182zM55.8 90.447l3.6 2.55 3.78 2.66.047.044a.3.3 0 01-.117.476v-.04l-4.72 2.46-3.84-2.73.81-5.18.018-.07a.31.31 0 01.422-.17zm.52-3.31l-.145.209-1.335 1.881a2.67 2.67 0 00-.46 1.19l-1.36 8.29-.016.171a2.23 2.23 0 001.016 2 2.11 2.11 0 002.17.06l7.51-3.67.112-.073c.744-.542 2.103-2.63 2.398-3.038l14.51-20.51-9.86-7z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-miterlimit":"20","stroke-width":"2","d":"M70 120c22.091 0 40-17.909 40-40S92.091 40 70 40 30 57.909 30 80s17.909 40 40 40z"}})])
          )
        }
      }
    